module.exports = __webpack_public_path__ + "static/media/n20.18e0c1b7.jpg";